import type { UUID } from '@/types/Id'

interface PromptsQueryKeyArgs {
  orgId: UUID | ''
}

interface PromptQueryKeyArgs {
  promptId: UUID | ''
}

export const promptsQueryKeys = {
  all: () => ['prompts'] as const,
  organization: (keyArgs: PromptsQueryKeyArgs) =>
    ['prompts', keyArgs.orgId] as const,
  count: (keyArgs: PromptsQueryKeyArgs) =>
    ['prompts', keyArgs.orgId, 'count'] as const,
  references: (keyArgs: PromptsQueryKeyArgs & { slugs: string[] }) =>
    ['prompts', keyArgs.orgId, 'references', keyArgs.slugs] as const,
  usage: (keyArgs: PromptsQueryKeyArgs & { sinceDay: string }) =>
    ['prompts', keyArgs.orgId, 'usage', keyArgs.sinceDay] as const,
}

// Outside the `prompts` root: creating a playbook invalidates that root, and
// the library only changes with a deploy.
export const playbookLibraryQueryKeys = {
  list: (keyArgs: PromptsQueryKeyArgs) =>
    ['playbook-library', keyArgs.orgId] as const,
  playbook: (keyArgs: PromptsQueryKeyArgs & { slug: string }) =>
    ['playbook-library', keyArgs.orgId, keyArgs.slug] as const,
}

export const promptQueryKeys = {
  prompt: (keyArgs: PromptQueryKeyArgs) =>
    ['prompt', keyArgs.promptId] as const,
  activity: (keyArgs: PromptQueryKeyArgs) =>
    ['prompt', keyArgs.promptId, 'activity'] as const,
}

interface PlaybookRunGradeQueryKeyArgs {
  sessionId: UUID | ''
  enterToolCallId: string
  exitedAt: string | null
}

export const playbookRunQueryKeys = {
  allVerdicts: () => ['playbook-run-verdicts'] as const,
  allGrades: () => ['playbook-run-grade'] as const,
  verdicts: (keyArgs: { sessionId: UUID | ''; exits: string }) =>
    ['playbook-run-verdicts', keyArgs.sessionId, keyArgs.exits] as const,
  grade: (keyArgs: PlaybookRunGradeQueryKeyArgs) =>
    [
      'playbook-run-grade',
      keyArgs.sessionId,
      keyArgs.enterToolCallId,
      keyArgs.exitedAt,
    ] as const,
}
